import script from "./MobileThumbnails.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileThumbnails.vue?vue&type=script&lang=ts&setup=true"

import "./MobileThumbnails.vue?vue&type=style&index=0&id=2c80920e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c80920e"]])

export default __exports__